module.exports = __webpack_public_path__ + "img/53_28.d6345fbf.png";